import { useDeviceDetail } from "@/api/device-http-functions";
import { usePageLinksForUser } from "@/hooks/usePageLinksForUser";
import { getSiteTag } from "@/utils/utils";
import { PropsWithChildren, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router";

const SiteRouteFixer = ({
    children,
    enforceSiteTag,
}: PropsWithChildren<{ enforceSiteTag: boolean }>) => {
    const { deviceIdentity, deviceGroupTag } = useParams<{
        deviceIdentity: string;
        deviceGroupTag: string;
    }>();

    const location = useLocation();
    const { getDeviceLink } = usePageLinksForUser();

    const { data: device } = useDeviceDetail(deviceIdentity!, undefined, {
        query: { enabled: !!deviceIdentity, retry: false },
    });

    const navigate = useNavigate();

    useEffect(() => {
        if (!enforceSiteTag) return;
        if (!device) return;

        const deviceSiteTag = getSiteTag(device);

        if (deviceGroupTag !== (deviceSiteTag ?? "unassigned")) {
            const trailingURL = location.pathname
                .split(`/${deviceIdentity}/`)
                .at(1);

            const target = getDeviceLink(
                device,
                trailingURL ? `/${trailingURL}` : undefined,
            );
            if (location.pathname !== target) {
                navigate(target, { replace: true });
            }
        }
    }, [
        device,
        deviceGroupTag,
        deviceIdentity,
        enforceSiteTag,
        getDeviceLink,
        location.pathname,
        navigate,
    ]);

    return children;
};

export default SiteRouteFixer;
